import { enable_legacy_mode_flag } from './index.js';

enable_legacy_mode_flag();
